import React from 'react';
import './invoice-preview.style.scss';
import InvoicePreviewImage from '../../../../public/assets/png/invoice_preview_swe.png';
import { useTranslation } from 'react-i18next';

export interface InvoicePreviewProps {
    brandName?: string;
    logoUrl?: string;
    className?: string;
    width?: string;
}

/**
 * Invoice Preview Component
 * Shows a preview of how the invoice will look with the configured branding
 * Matches the Figma design specifications exactly
 */
export const InvoicePreview: React.FC<InvoicePreviewProps> = ({
    brandName = "YOUR LOGO",
    logoUrl,
    className = 'w-sm-100 w-50',
    width = '340px'
}) => {
    const { t } = useTranslation()
    return (
        <div className={`invoice-preview ${className}`} >
                <div className="invoice-preview__header">
                    <span className="invoice-preview__label">{t('PREVIEW_LOGO')}</span>
                </div>
            <div className="invoice-preview__document">
                <div className="invoice-preview__invoice-header">
                    <div className="invoice-preview__logo-section d-flex">
                        <img src={InvoicePreviewImage} className='mx-auto' alt="" />
                    </div>
                </div>
            </div>
            <div className="invoice-preview__footer-note">
                ** {t('NO_LOGO_NOTICE')}
            </div>
        </div>
    );
};
